import React, {PureComponent} from 'react';

import * as environment from '../../../modules/environment';

import {Col, Button, Row, Card, CardBody} from 'reactstrap';
import TextSearch from '../../../components/TextSearch'
import * as http from '../../../modules/http';
import LoadingProgress from '../../../components/LoadingProgress';
import {
    admin_update_field,
    admin_sgroup_insert,
    admin_sgroup_update
} from '../../../redux/actions/AdminActions';
import Alert from '../../../components/Alert';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";
import Select from "../../../components/Select";


class EditStoreGroupForm extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false
        };
    }

    componentDidMount() {
    }

    editValue(store, label, newValue) {
        this.props.dispatch(admin_update_field(store, label, newValue));
    }

    saveStore() {

        const isAdding = (this.props.storeGroupInEdit.id === 0);

        //validation
        if (isAdding) {
            if (!this.props.storeGroupInEdit.name || this.props.storeGroupInEdit.name === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }

            if (!this.props.storeGroupInEdit.storeGroup || this.props.storeGroupInEdit.storeGroup === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            id: this.props.storeGroupInEdit.id,
            name: this.props.storeGroupInEdit.name,
            storeGroup: this.props.storeGroupInEdit.storeGroup
        };

        var requestUrl = 'store_group/update';
        if (isAdding) {
            requestUrl = 'store_group/new';
        }
        http.postToServer(
            requestUrl,
            storeData,
            (response) => {

                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(admin_sgroup_insert(response.data));
                }
                else {
                    this.props.dispatch(admin_sgroup_update(response.data));
                }

                //this.props.dispatch(fetchUserDataIfNeeded(true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    }

    changeStoresView(e) {
        let tmp = '';

        for(let indx in e) {
            if(indx === '0') {
                tmp = String(e[indx].value)
            }
            else {
                tmp += ',' + e[indx].value
            }
        }

        this.props.dispatch(admin_update_field('storeGroupInEdit', 'storeGroup', tmp));
    };

    render() {

        const isAdding = this.props.storeGroupInEdit.id === 0;

        let stores = [];

        for(let indx in this.props.stores){
            stores.push({value: this.props.stores[indx].id, label: this.props.stores[indx].name});
        }

        return (

            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <div className='card__title'>

                                {isAdding &&
                                    <h5 className='bold-text'>הוסף קבוצות חנויות</h5>
                                }

                                {!isAdding &&
                                    <h5 className='bold-text'>ערוך קבוצות חנויות</h5>
                                }

                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>שם קבוצה</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.storeGroupInEdit.name}
                                                    onChange={(value) => this.editValue('storeGroupInEdit', 'name', value)}/>
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>קבוצות חנויות</label>
                                    <div className='form__form-group-field'>
                                        <Select value={this.props.storeGroupInEdit.storeGroup}
                                                onChange={(e) => this.changeStoresView(e)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>

                            </form>

                            {this.state.error &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span>
                                    </p>
                                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                </Alert>
                            </Row>
                            }

                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>
                            }

                            {!this.state.saving &&
                            <span>
                                        <Button color='primary' size='sm'
                                                onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                                        < Button color='primary' size='sm'
                                                 onClick={() => this.saveStore()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                                    </span>
                            }
                            {
                                this.state.saving &&
                                <LoadingProgress/>
                            }
                        </CardBody>
                    </Card>
                </Col>

            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        storeGroupInEdit: state.admin.storeGroupInEdit,
        stores: state.admin.stores,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditStoreGroupForm))